import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Grid,
  GridItem,
  Input,
} from "@chakra-ui/react";
import React from "react";
import { Trans, useTranslation } from "react-i18next";

/**
 * Renders the cotract form
 * 
 * @param {Function} register - The form registration function
 * @param {Object} errors - The form errors object
 * @returns The contract form
 */
const ContractForm = ({ register, errors }) => {
  const { t } = useTranslation();

  return (
    <Grid
      gap={"8px"}
      templateColumns={{ base: "repeat(1, 1fr)", xl: "repeat(6, 1fr)" }}
      templateRows={{ base: "repeat(1, 1fr)", xl: "repeat(2, 1fr)" }}
    >
      <GridItem colSpan={{ base: 1, xl: 2 }} rowSpan={1}>
        <FormControl isInvalid={errors.policyNumber}>
          <FormLabel fontSize={12} htmlFor={"policyNumber"} fontWeight={400} color={"white"}>
            <Trans>beneficiaryFile.form.policyNumber.title</Trans>
          </FormLabel>
          <Input
            id={"policyNumber"}
            placeholder={t("beneficiaryFile.form.policyNumber.placeholder")}
            type={"text"}
            backgroundColor={"#2D313A"}
            {...register("policyNumber", {
              required: t("beneficiaryFile.form.policyNumber.required"),
            })}
          />
          <FormErrorMessage fontSize={8}>
            {errors.policyNumber && errors.policyNumber.message}
          </FormErrorMessage>
        </FormControl>
      </GridItem>
      <GridItem colSpan={1} rowSpan={1}>
        <FormControl>
          <FormLabel fontSize={12} htmlFor={"effectiveDate"} fontWeight={400} color={"white"}>
            <Trans>beneficiaryFile.form.effectiveDate.title</Trans>
          </FormLabel>
          <Input
            id={"effectiveDate"}
            type={"date"}
            style={{ colorScheme: "dark" }}
            backgroundColor={"#2D313A"}
            {...register("effectiveDate")}
          />
        </FormControl>
      </GridItem>
      <GridItem colSpan={1} rowSpan={1}>
        <FormControl>
          <FormLabel fontSize={12} htmlFor={"endDate"} fontWeight={400} color={"white"}>
            <Trans>beneficiaryFile.form.endDate.title</Trans>
          </FormLabel>
          <Input id={"endDate"} type={"date"} style={{ colorScheme: "dark" }} backgroundColor={"#2D313A"} {...register("endDate")} />
        </FormControl>
      </GridItem>
      <GridItem colSpan={{ base: 1, xl: 2 }} rowSpan={1}>
        <FormControl>
          <FormLabel fontSize={12} htmlFor={"instruction"} fontWeight={400} color={"white"}>
            <Trans>beneficiaryFile.form.instruction.title</Trans>
          </FormLabel>
          <Input
            id={"instruction"}
            placeholder={t("beneficiaryFile.form.instruction.placeholder")}
            type={"text"}
            backgroundColor={"#2D313A"}
            {...register("instruction")}
          />
        </FormControl>
      </GridItem>
      <GridItem colSpan={1} rowSpan={1}>
        <FormControl>
          <FormLabel fontSize={12} htmlFor={"externNumber"} fontWeight={400} color={"white"}>
            <Trans>beneficiaryFile.form.externNumber.title</Trans>
          </FormLabel>
          <Input
            id={"externNumber"}
            placeholder={t("beneficiaryFile.form.externNumber.placeholder")}
            type={"text"}
            backgroundColor={"#2D313A"}
            {...register("externNumber")}
          />
        </FormControl>
      </GridItem>
      <GridItem colSpan={1} rowSpan={1}>
        <FormControl>
          <FormLabel fontSize={12} htmlFor={"pack"} fontWeight={400} color={"white"}>
            <Trans>beneficiaryFile.form.pack.title</Trans>
          </FormLabel>
          <Input
            id={"pack"}
            placeholder={t("beneficiaryFile.form.pack.placeholder")}
            type={"text"}
            backgroundColor={"#2D313A"}
            {...register("pack")}
          />
        </FormControl>
      </GridItem>
      <GridItem colSpan={{ base: 1, xl: 2 }} rowSpan={1}>
        <FormControl>
          <FormLabel fontSize={12} htmlFor={"productNumber"} fontWeight={400} color={"white"}>
            <Trans>beneficiaryFile.form.productNumber.title</Trans>
          </FormLabel>
          <Input
            id={"productNumber"}
            placeholder={t("beneficiaryFile.form.productNumber.placeholder")}
            type={"text"}
            backgroundColor={"#2D313A"}
            {...register("productNumber")}
          />
        </FormControl>
      </GridItem>
      <GridItem colSpan={{ base: 1, xl: 2 }} rowSpan={1}>
        <FormControl>
          <FormLabel fontSize={12} htmlFor={"contractStatus"} fontWeight={400} color={"white"}>
            <Trans>beneficiaryFile.form.contractStatus.title</Trans>
          </FormLabel>
          <Input
            id={"contractStatus"}
            placeholder={t("beneficiaryFile.form.contractStatus.placeholder")}
            type={"text"}
            backgroundColor={"#2D313A"}
            {...register("contractStatus")}
          />
        </FormControl>
      </GridItem>
    </Grid>
  );
};

export default ContractForm;
